import { Button, TableCell } from "@mui/material";
import {FaCheck, FaEye, FaPencilAlt, FaTimes} from "react-icons/fa";
import {Link} from "react-router-dom";
import React from "react";
const ActionsCell = ({ update, handleActionClick, handleShowDetails,panelId }) => (
  <TableCell align="center">
    <div className="flex gap-2 justify-center items-center">
      <Button
        variant="outlined"
        color="info"
        size="small"
        onClick={() => handleShowDetails(update)}
      >
        View Details
      </Button>
        <Link
            to={`/Panels/Edit/${panelId}`}
            color="inherit"
            underline="none"
        >
            <FaPencilAlt className="text-[#6c757d]" />
        </Link>
        <Link
            to={`/Panels/${panelId}`}
            color="inherit"
            underline="none"
        >
            <FaEye className="text-[#6c757d]" />
        </Link>
      {update.status === "pending" && (
        <>
          <Button
            variant="contained"
            color="success"
            startIcon={<FaCheck />}
            onClick={() => handleActionClick(update.id, "approve")}
            size="small"
          >
            Approve
          </Button>
          <Button
            variant="contained"
            color="error"
            startIcon={<FaTimes />}
            onClick={() => handleActionClick(update.id, "reject")}
            size="small"
          >
            Reject
          </Button>
        </>
      )}
    </div>
  </TableCell>
);
export default ActionsCell;
